import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, ClockIcon, PhoneIcon, InstagramIcon } from 'lucide-react';
interface FooterProps {
  isDark: boolean;
  minimal?: boolean;
}
export function Footer({
  isDark,
  minimal = false
}: FooterProps) {
  return <footer className="border-t border-slate-200 dark:border-white/5 pt-16 pb-8 bg-white dark:bg-[#0f1629] transition-colors duration-300 relative z-10" data-id="element-56">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className={`${minimal ? 'flex justify-center' : 'grid grid-cols-1 md:grid-cols-3 gap-12'} mb-12`} data-id="element-58">
          <div className={minimal ? 'text-center' : 'md:col-span-1'} data-id="element-59">
            <Link to="/" className={`flex items-center mb-4 group ${minimal ? 'justify-center' : ''}`} data-id="element-60">
              <img src="https://cdn.magicpatterns.com/uploads/2ta7BLC2bm2HydpkJQJwcY/Logo_Transparent.png" alt="Scale Finance Strategies" className="h-8 w-auto object-contain dark:brightness-0 dark:invert" data-id="element-61" />
            </Link>
            <p className={`text-slate-500 dark:text-slate-400 text-xs leading-relaxed ${minimal ? 'max-w-md mx-auto' : ''}`} data-id="element-62">
              Built for Australians that want more than just one property — we
              help you scale your portfolio through smarter strategy, education
              and the right team.
            </p>

            <div className={`mt-5 space-y-3 ${minimal ? 'inline-flex flex-col items-center' : ''}`} data-id="element-63">
              <div className="flex items-center gap-2.5" data-id="element-64">
                <MailIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-65" />
                <a href="mailto:liam@scalefinancestrategies.com.au" className="text-xs text-slate-500 dark:text-slate-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-66">
                  liam@scalefinancestrategies.com.au
                </a>
              </div>
              <div className="flex items-center gap-2.5" data-id="element-67">
                <PhoneIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-68" />
                <a href="tel:+610403191672" className="text-xs text-slate-500 dark:text-slate-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-69">
                  +61 0403 191 672
                </a>
              </div>
              <div className="flex items-center gap-2.5" data-id="element-70">
                <InstagramIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-71" />
                <a href="https://www.instagram.com/scalefinancestrategies?utm_source=qr" target="_blank" rel="noopener noreferrer" className="text-xs text-slate-500 dark:text-slate-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-72">
                  @scalefinancestrategies
                </a>
              </div>
              <div className="flex items-center gap-2.5" data-id="element-73">
                <ClockIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-74" />
                <span className="text-xs text-slate-500 dark:text-slate-400" data-id="element-75">
                  Mon – Fri: 8:30 AM – 5:30 PM AWST
                </span>
              </div>
            </div>
          </div>

          {!minimal && <>
              <div data-id="element-76">
                <h4 className="text-slate-900 dark:text-white font-semibold mb-4 text-sm" data-id="element-77">
                  Quick Links
                </h4>
                <ul className="space-y-2.5 text-sm text-slate-500 dark:text-slate-400" data-id="element-78">
                  <li data-id="element-79">
                    <Link to="/#services" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-80">
                      Services
                    </Link>
                  </li>
                  <li data-id="element-81">
                    <Link to="/#about" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-82">
                      About
                    </Link>
                  </li>
                  <li data-id="element-83">
                    <Link to="/#contact" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-84">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>

              <div data-id="element-85">
                <h4 className="text-slate-900 dark:text-white font-semibold mb-4 text-sm" data-id="element-86">
                  Legal
                </h4>
                <ul className="space-y-2.5 text-sm text-slate-500 dark:text-slate-400" data-id="element-87">
                  <li data-id="element-88">
                    <Link to="/legal#privacy" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-89">
                      Privacy Policy
                    </Link>
                  </li>
                  <li data-id="element-90">
                    <Link to="/legal#complaints" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-91">
                      Complaints Policy
                    </Link>
                  </li>
                  <li data-id="element-92">
                    <Link to="/legal#terms" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-93">
                      Website Terms
                    </Link>
                  </li>
                </ul>
              </div>
            </>}
        </div>

        <div className="pt-8 border-t border-slate-200 dark:border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-94">
          <p className="text-xs text-slate-400 dark:text-slate-500 text-center md:text-left" data-id="element-95">
            © 2026 Scale Finance Strategies Pty Ltd. All rights reserved. ACN
            654344260
          </p>
          <p className="text-xs text-slate-400 dark:text-slate-500 max-w-xl text-center md:text-right leading-relaxed" data-id="element-96">
            General Advice Warning: All information on this website is general
            in nature and does not consider your personal circumstances. Any
            tools, calculators, or examples provided are for illustrative
            purposes only and may not be accurate or reflect your situation. You
            should seek personalised advice before making any financial
            decisions.
          </p>
        </div>
      </div>
    </footer>;
}